import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-network-warning-modal',
  templateUrl: './network-warning-modal.component.html',
  styleUrl: './network-warning-modal.component.scss',
})
export class NetworkWarningModalComponent {
  constructor(private dialogRef: MatDialogRef<NetworkWarningModalComponent>) {}

  okayClicked() {
    this.dialogRef.close();
  }
}
